import React from 'react'
import Seminars from '../../components/Seminars'
import SeminarActions from '../../components/Seminars/SeminarActions'
import RoomFooterActions from '../../components/Seminars/RoomFooterActions.js'

const Room = ({
    isFetchingRooms,
    isFetchingConferenceDetails,
    conferenceDetails,
    ...rest
  }) => (
  <div className="w-100 flex">
    <div
      className={`${(rest.upcoming && rest.upCommingRooms.length !== 0) ||
      (!rest.upcoming && rest.previousRooms.length !== 0)
        ? 'flex-auto'
        : ''}`}
      style={{width: '25%'}}
    >
      <Seminars pathname={rest.location.pathname}/>
    </div>
    {((rest.upcoming && rest.upCommingRooms.length !== 0) || (!rest.upcoming && rest.previousRooms.length !== 0)) ?
      <div className="w-75 flex-auto">
        <SeminarActions
          pathname={rest.location.pathname}
          isFetchingRooms={isFetchingRooms}
          isFetchingPreviousRooms={rest.isFetchingPreviousRooms}
          isFetchingConferenceDetails={isFetchingConferenceDetails}
          isFetchingParticipantList={rest.isFetchingParticipantList}
          isFetchingRecordList={rest.isFetchingRecordList}
          isFetchingList={rest.isFetchingList}
          participants={rest.participants}
          addParticipant={rest.addParticipant}
          inviteParticipant={rest.inviteParticipant}
          importParticipants={rest.importParticipants}
          deleteParticipant={rest.deleteParticipant}
          fetchRecordList={rest.fetchRecordList}
          recordings={rest.recordings}
          conferenceDetails={conferenceDetails}
          scheduleSubmitted={rest.scheduleSubmitted}
          startDate={rest.startDate}
          scheduleUpdated={rest.scheduleUpdated}
          selectConferenceId={rest.selectConferenceId}
          fetchParticipantList={rest.fetchParticipantList}
          fetchContactList={rest.fetchContactList}
          contacts={rest.contacts}
          updateConferenceSchedule={rest.updateConferenceSchedule}
          updateConferenceSettings={rest.updateConferenceSettings}
          updateConferenceDetails={rest.updateConferenceDetails}
        />
        <RoomFooterActions
          upcoming={rest.upcoming}
          userName={rest.name}
          userid={rest.userid}
          pathname={rest.location.pathname}
          selectConferenceId={rest.selectConferenceId}
          conferenceDetails={conferenceDetails}
          respondToInvitation={rest.respondToInvitation}
          deleteConference={rest.deleteConference}
        />
      </div> : ''}
  </div>
)

export default Room



// WEBPACK FOOTER //
// ./src/routes/Room/Room.js